import { HONEYPOT_IDS } from './honeypot_helper'

export const Honeypot = () => {
  return (
    <div style={{ opacity: 0.01, position: 'absolute', top: 0, left: -9000, height: 0, width: 0, zIndex: -1 }}>
      {HONEYPOT_IDS.map((id: string) => (
        <div key={id}>
          <label htmlFor={id}>
            <input autoComplete="off" id={id} name={id} placeholder={id} />
          </label>
        </div>
      ))}
    </div>
  )
}
